<article
  class="cui-card parameter-node"
  [class.cui-card--interactive]="interactive()"
  [attr.role]="interactive() ? 'button' : null"
  [attr.tabindex]="interactive() ? 0 : null"
  (click)="activated.emit()"
  (keydown.enter)="activated.emit()"
  (keydown.space)="activated.emit()">
  <header class="cui-card__header parameter-node__header">
    <span class="material-symbols-outlined">tune</span><strong>Parameters</strong>
  </header>
  <app-timeline-preview [data]="data()" [parameters]="parameters()"></app-timeline-preview>
</article>
